import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-route2',
    templateUrl: './route2.component.html',
    styleUrls: ['./route2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Route2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
